import React, { useState } from "react";

import { Box } from "@chakra-ui/react";
import { pauseIndividualSavings } from "api/individual-user-management";
import { ReactComponent as PauseIcon } from "assets/icons/pause-rounded.svg";
import { useIndividuals } from "contexts/individuals-context";
import { transactionLimitModalHeaderCss } from "features/individuals/individual-details/styles";

import { Button } from "ui/button";
import { customErrorToast, customSuccessToast } from "ui/custom-toast";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { DEFAULT_PAGINATION_DATA } from "ui/pagination";
import { Heading3, Paragraph3 } from "ui/typography";

import { IPauseSavingsModalProps } from "./types";

export const PauseSavingsModal = (props: IPauseSavingsModalProps) => {
  const {
    isOpen,
    setIsOpen,
    handleTogglePauseSavingsModal,
    id,
    type,
    walletId,
  } = props;

  const [isPausing, setIsPausing] = useState(false);

  const { handleGetIndividualSavings } = useIndividuals();

  const handlePauseSavings = async () => {
    // if (!individualDetails) return;
    setIsPausing(true);
    try {
      const { error, message } = await pauseIndividualSavings({
        id: id || "",
        plan: type || "flex",
      });
      if (error) {
        customErrorToast({
          message,
        });
        // setIsOpen(false);
        handleTogglePauseSavingsModal();
      } else {
        customSuccessToast({
          message: "Savings Paused Successfully",
        });
        // await handleGetIndividualDetails(individualDetails?.id);
        await handleGetIndividualSavings({
          walletId: +walletId,
          page: DEFAULT_PAGINATION_DATA.page,
          limit: DEFAULT_PAGINATION_DATA.page,
        });
        handleTogglePauseSavingsModal();
        // setIsOpen(false);
      }
    } catch (error) {
      console.error("Error: ", error);
      // setIsOpen(false);
      handleTogglePauseSavingsModal();
    }
    setIsPausing(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        width: "400px",
        // height: "304px",
        padding: "24px",
        gap: "32px",
      }}
      allowOutsideClick={false}
    >
      <Box className="flex flex-col gap-5">
        <ModalHeader
          modalType="others"
          HeaderIcon={<PauseIcon />}
          modalHeaderCss={transactionLimitModalHeaderCss}
        />
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#101828"
            fontWeight="600"
          >
            Pause This Goal Savings
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
        </Box>
      </Box>
      <Box
        css={{
          //   height: "44px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <Button
          variant="outline"
          textColor="#344054"
          border="1px solid #D0D5DD"
          className="w-[170px]"
          onClick={handleTogglePauseSavingsModal}
          disabled={isPausing}
        >
          Cancel
        </Button>
        <Button
          variant="solid"
          textColor="#ffffff"
          border="1px solid #00535C"
          className="w-[170px]"
          onClick={handlePauseSavings}
          disabled={isPausing}
          loading={isPausing}
          loadingText="Pausing..."
        >
          Confirm
        </Button>
      </Box>
    </Modal>
  );
};
